import { BookDashed } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

/**
 * The scope of a standalone conversation, near its composer (spec `trust-indicators`): one quiet
 * line saying its answers use no project knowledge.
 */
export function NoKnowledgeNote(props: { className?: string }) {
  const { t } = useTranslation();
  return (
    <p className={cn("inline-flex items-center gap-1.5 text-xs text-fg-muted", props.className)}>
      <BookDashed aria-hidden="true" className="size-3.5 shrink-0" strokeWidth={1.75} />
      <span>{t("standalone.noKnowledge")}</span>
    </p>
  );
}
